import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import {imageMap} from "../../images/imageMap.ts";
import Icon from "../../components/selfcare/Icon.tsx";
import {Link} from "react-router-dom";
import QuestionAnswerComponent, {Question} from "../../components/help/QuestionAnswerComponent.tsx";
import CallMeRTOComponent from "../../components/callMe/CallMeRTOComponent.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import TDC5GHeroComponent from "../../components/hero/TDC5GHeroComponent.tsx";
import TDC5GQualitySectionComponent from "../../components/tdc5g/TDC5GQualitySectionComponent.tsx";
import TDC5GSetupStepsSectionComponent from "../../components/tdc5g/TDC5GSetupStepsSectionComponent.tsx";
import TDC5GTrophySectionComponent from "../../components/tdc5g/TDC5GTrophySectionComponent.tsx";
import TDC5GCoverageMap from "../../components/tdc5g/TDC5GCoverageMap.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import Routing from "../../Routing.ts";
import IconArrow from "../../components/icons/IconArrow.tsx";
import {CallMePhoneNumbers} from "../../util/contact.ts";

const questions: Question[] = [
    {
        question: 'Hvor hurtigt er 5G-internet?',
        answer: <>
            <p>
                5G-internet er markant hurtigere end tidligere generationer af mobilnetværk, og hastighederne kan variere afhængigt af en række faktorer, såsom placering, netværksbelastning og det anvendte <Link
                to="/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser"
            >frekvensbånd</Link> (mængde af GHz).
                Vi kan dække en 5G-hastighed helt op til 1000 Mbit på dit mobile bredbånd.
            </p>
            <p>
                Ved at lave et adresseopslag, kan du se hvilken hastighed, som er tilgængeligt på din adresse. <button
                    className={'link'}
                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                >Tjek din adresse her</button>.
            </p>
            <p>
                Hvis du vil teste din nuværende hastighed, kan du tage denne <Link to="/hjaelp/internet-og-wifi/hastighedstest">5G-hastighedstest</Link>.
            </p>
        </>
    },
    {
        question: 'Hvad er down- og uploadhastigheden på 5G-internet?',
        answer: <>
            <p>
                Den oplevede indendørs hastighed kan ikke defineres generelt, da det afhænger af udstyr, bygninger og afstand til nærmeste 5G-mast.
                Hvis du vil tjekke, hvad du kan få af 5G-hastighed på din adresse, <button
                    className={'link'}
                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                >kan du gøre det her</button>.
            </p>
            <p>
                5G-routeren du får med i dit abonnement er ikke til udendørs brug, men du kan godt gøre brug af dens wifi udendørs, skulle du sidde med en af dine enheder i f.eks. din have.
                Styrken af dit wifi kan godt svækkes ved udendørs brug, da signalet skal igennem vægge og andre udendørs forhindringer.
            </p>
        </>
    },
    {
        question: 'Kan jeg game med mit 5G-internet?',
        answer: <p>
            Ja, du kan sagtens game med dit 5G-internet, men vi anbefaler, at du køber <Link to={Routing.Broadband.Fiber}>fibernet</Link> til <Link to="/hjaelp/bestilling/internet-til-gaming">gaming,</Link> da det ikke bliver påvirket af vejrforhold og dermed er mere stabilt.
        </p>
    },
    {
        question: 'Hvad koster 5G-internet?',
        answer: <>
            <p>
                Lige nu kan du få 5G-internet for kun 199,-/md. I de første 3 måneder.
                Herefter er normalprisen 279,-/md.
                Den præcise 5G-hastighed, du kan få, afhænger af din adresse.
            </p>
            <p>
                <button
                    className={'link'}
                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                >Slå din adresse op her</button>.
            </p>
        </>
    },
    {
        question: 'Hvilket frekvensbånd kan 5G-internet køre på?',
        answer: <p>
            5G kan ligesom ved fiberbredbånd og bredbånd via kabel-tv køre på både <Link to="/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser">2,4 og 5&nbsp;GHz</Link>.
            Frekvensen afhænger af routeren, og ikke forbindelsen.
        </p>
    },
    {
        question: 'Er trådløst internet og 5G-internet det samme?',
        answer: <p>
            Nej, det er ikke det samme.
            Trådløst internet er enhver form for internetforbindelse, der ikke kræver fysiske kabler for at forbinde enheder til internettet.
            Trådløst internet dækker typisk over et lokalt område, som et hjem, mens 4G eller 5G kan dække hele byområder, afhængigt af netværk.
            Du kan læse mere om <Link to="/hjaelp/internet-og-wifi/info-om-internet-og-wifi">forskellene på trådløst internet, wifi mm. her</Link>.
        </p>
    },
    {
        question: 'Tilbyder i mobilabonnementer?',
        answer: <p>
            Nej, vi tilbyder ikke mobilabonnementer eller køb af mobil, men udelukkende en 5G-internetforbindelse med en tilhørende router og SIM-kort til.
        </p>
    },
]

export default function TDC5GPage() {
    ScrollToTop()
    useDatalayer()
    setTitleAndMetaDescription(
        '5G-internet med fri data | Danmarks bedste 5G-dækning',
        'Med 5G-internet fra Hiper kommer du hurtigt online og får en lynhurtig 5G-lånerouter med i dit abonnement. Få op til 1000 Mbit fra 199,-/md.'
    )

    return (
        <div className={"page-products-tdc5g"}>
            <TDC5GHeroComponent/>
            <TDC5GQualitySectionComponent/>
            <TDC5GSetupStepsSectionComponent/>
            <TDC5GTrophySectionComponent />

            <section className="mbb-includes">
                <div className="content content--medium">
                    <h2 className="heading heading--montserrat heading--big">Det får du med i dit 5G-abonnement:</h2>
                    <div className="item">
                        <div className="text">
                            <h3 className="heading heading--montserrat heading--medium heading--left">Fri data</h3>
                            <p>
                                Med mobilt internet fra Hiper får du fri data.
                                Ja, du læste helt rigtigt &ndash; fri data!
                                Så du kan bruge dit 5G-internet helt ubegrænset og surfe og streame lige så meget, som du har lyst til.
                            </p>
                        </div>
                        <img src={imageMap.products.surfing_5g_router} alt="Surf løs med 5G-internet fra Hiper!"/>
                    </div>
                    <div className="item alt">
                        <div className="text">
                            <h3 className="heading heading--montserrat heading--medium heading--left">5G-router til SIM-kort</h3>
                            <p>
                                I dit 5G-abonnement hos Hiper får du en lynhurtig 5G-lånerouter samt et SIM-kort, som du skal bruge til opsætning af dit 5G-internet.
                                Du kan læse mere om <a
                                href="/5g-internet-vejledning"
                                target="_blank"
                            >opsætningen af din 5G-router her</a>.
                            </p>
                        </div>
                        <img src={imageMap.products.zyxel_nr5307_back_with_sim} alt="Hipers lynhurtige 5G-router."/>
                    </div>
                    <div className="item">
                        <div className="text">
                            <h3 className="heading heading--montserrat heading--medium heading--left">Adgang til egen selvbetjening</h3>
                            <p>
                                Når du bestiller dit 5G-abonnement hos Hiper, får du adgang til din egen selvbetjening, Mit Hiper, hvor du kan finde dine regninger, skifte betalingskort m.m.
                            </p>
                        </div>
                        <img
                            src={imageMap.products.selfcare}
                            alt="Med 5G-internet fra Hiper får du adgang til din egen selvbetjening via Mit Hiper."
                        />
                    </div>
                </div>
            </section>



            <section className="mbb-router">
                <div className="content content--medium">
                    <h2 className="heading heading--montserrat heading--big">Den komplete 5G-router til dit 5G-abonnement</h2>
                    <div className="text-image-container">
                        <div className="text">
                            <p>
                                Lånerouteren du får med i dit 5G-abonnement er en rigtig god 5G-router, som giver lynhurtige datahastigheder og understøtter både LAN og wifi.
                            </p>
                            <p>
                                Routeren er flytbar, så du kan bl.a. tage den med i <Link to="/hjaelp/bestilling/internet-i-sommerhus">sommerhus</Link> eller med på farten.
                                Den har et enkelt design og er kun til indendørs brug, så det er en oplagt mulighed for at få 5G-internet til hjemmet.
                            </p>
                            <p>
                                Det er en 5G-router til SIM-kort, men den har også to ethernet LAN-porte, hvis du vil foretage en <Link to="/hjaelp/internet-og-wifi/hastighedstest">5G-hastighedstest</Link> eller koble dit internet direkte til din enhed fra 5G-routeren via et netværkskabel.
                            </p>
                            <p>
                                Hvilken 5G-router du præcist får med i dit abonnement, afhænger af hvad vi har tilgængeligt når du bestiller.
                                Den ene er en Zyxel NR5307 router og den anden er en Huawei H158-381 router.
                                Begge routere er super gode og leverer en hurtig 5G-forbindelse til hjemmet.
                            </p>
                        </div>
                        <img
                            className="hide-on-small-devices"
                            src={imageMap.products.zyxel_nr5307}
                            alt="5G-router som du får med i dit 5G-abonnement."
                        />
                        <img
                            className="hide-on-large-devices"
                            src={imageMap.products.zyxel_nr5307_white_square}
                            alt="5G-router til SIM-kort som du får til låns i dit internetabonnement."
                        />
                    </div>
                </div>
            </section>

            <section className="mbb-advantages">
                <div className="content content--narrow">
                    <h2 className="heading heading--montserrat heading--big">3 fordele ved at vælge 5G-internet fra Hiper</h2>
                    <div className="box-container">
                        <div className="box">
                            <span className="number">1</span>
                            <div className="text">
                                <h3 className="heading heading--montserrat heading--medium heading--left">Meget nem installation</h3>
                                <p>
                                    Med 5G-bredbånd skal du blot indsætte SIM-kortet i 5G-routeren, tilslutte strømstikket og koble dine enheder til wifi.
                                    Nemt og sikkert.
                                </p>
                            </div>
                        </div>
                        <div className="box">
                            <span className="number">2</span>
                            <div className="text">
                                <h3 className="heading heading--montserrat heading--medium heading--left">Lynhurtig 5G-hastighed</h3>
                                <p>
                                    Du kan nå op til 1000 Mbit i download-hastighed med vores 5G-bredbånd.
                                    Du kan nå høje 5G-hastigheder til bl.a. at surfe, sende e-mails og streame på livet løs.
                                    God 5G-hastighed og stabil dækning.
                                </p>
                            </div>
                        </div>
                        <div className="box">
                            <span className="number">3</span>
                            <div className="text">
                                <h3 className="heading heading--montserrat heading--medium heading--left">Sublim 5G-router til SIM-kort</h3>
                                <p>
                                    Du får en lånerouter med i dit abonnement, som er bygget til at levere et stærkt og stabilt wifi-signal til alle dine enheder.
                                    Du får altså det bedste udstyr til at få leveret dit 5G-internet.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <CallMeRTOComponent phoneNumberSet={CallMePhoneNumbers.Broadband} className={"rto--section page-products"}/>

            <section className="mbb-what">
                <div className="content content--narrow">
                    <div className="item">
                        <div className="text">
                            <h2 className="heading heading--montserrat heading--big heading--left">Hvad er 5G-internet?</h2>
                            <p>
                                5G er den nyeste generation af det mobile netværk, der leverer en hurtigere og mere pålidelig internetforbindelse end tidligere netværk som 3G og 4G.
                                5G-internet er designet til at håndtere langt højere hastigheder, har lavere latenstid (forsinkelse på data), og en højere kapacitet til at understøtte flere enheder på samme tid, end 3G og 4G.
                            </p>
                            <p>
                                Det er ikke kun din mobiltelefon, som anvender 5G for at få adgang til internettet.
                                Nu kan du også få 5G-internet til hjemmet via en 5G-router, et SIM-kort og et strømstik.
                            </p>
                            <p>
                                5G-internet kan være ideelt til dig, som ikke kan få fibernet på adressen, men ønsker en stabil og god forbindelse, som er nem at installere og er fleksibel.
                            </p>
                        </div>
                    </div>
                    <div className="item">
                        <div className="text">
                            <h2 className="heading heading--montserrat heading--big heading--left">Hvad er forskellen på 4G og 5G?</h2>
                            <p>
                                5G er betydeligt hurtigere, har lavere latenstid, større kapacitet og er mere energieffektivt end 4G.
                                5G er bygget op omkring andre antenneteknologier end 4G, og der er desuden langt flere 5G-antenner rundt omkring, som også er med til at øge netværkskapaciteten.
                                4G kan trække op til 250 Mbit, hvorimod 5G kan trække op til 1000 Mbit.
                            </p>
                            <p>
                                5G blev lanceret i 2020 af TDC NET og deres 5G-dækning dækker nu 99,9% af Danmarks befolkning, hvilket også gælder vores dækning, da vi benytter os af TDC NET&rsquo;s 5G.
                                5G bliver kontinuerligt udrullet i hele landet og bliver løbende udviklet og opdateret.
                                4G er stadig meget anvendeligt og udbredt, især i områder, hvor 5G-netværk endnu ikke er tilgængelige.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="mbb-faq">
                <div className="content content--narrow">
                    <h2 className="heading heading--montserrat heading--big">Spørgsmål omkring 5G-internet</h2>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </section>

            <section className="mbb-coverage">
                <div className="content">
                    <h2 className="heading heading--montserrat heading--big">5G-dækningskort</h2>
                    <p>
                        Vi dækker 5G-internet i stort set hele Danmark via TDC NET.
                        5G-internet kører på 5.&nbsp;generation af det eksisterende mobile netværk, som er hurtigt, sikkert og trådløst.
                        Du kan bruge det til alle dine enheder som mobil, computer, tablet og TV.
                        Alle de markerede områder på kortet, dækker vi med 5G-internet.
                    </p>
                </div>

                <div className="content content--medium">
                    <TDC5GCoverageMap />
                    <p className="coverage-map-disclaimer">
                        Vi kan ikke garantere at kunne levere til alle adresser i de markerede områder.
                    </p>
                </div>

                <div className="content">
                    <h3 className="heading heading--montserrat heading--medium">5G-dækningskort</h3>
                    <p>
                        På dækningskortet har vi markeret alle de områder, som vi dækker med vores mobile internet.
                        Vi dækker kun 5G-områder med mindst 100 Mbit i hastighed, så du er sikret den bedste forbindelse.
                        Men du kan stadigvæk godt tage dit 5G-internet med op i dit <Link to="/hjaelp/bestilling/internet-i-sommerhus">sommerhus,</Link> selvom der ikke nødvendigvis er 100 Mbit der.
                    </p>
                    <p>
                        Lige nu kan du få 5G-internet for kun 199,-/md. i de første 3 måneder.
                        Herefter er normalprisen 279,-/md.
                        Den præcise 5G-hastighed, du kan få, afhænger af din adresse.
                    </p>
                    <p className="align-center">
                        <button
                            className={'button button--montserrat big rounded with-icon'}
                            onClick={() => DispatchHighLightAddressSearchEvent(true)}
                        >
                            Slå din adresse op her
                            <Icon component={IconArrow}/>
                        </button>
                    </p>
                </div>
            </section>
        </div>
    )
}
